










































































































































































































































































import {
  Component, Vue, Watch, mixins, mapState,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import {
  formatDate, getStartDayOfDate, subtractMonthsFromDate,
} from '@/utils/date-utils';
import { BasicLineConfig, BasicLineSetting } from '@/components/graphs/line/basic-line';
import { CommonsStore, MyaaffiliateStore, Payload } from '@/state/modules';
import { getPercentageRate, toMoney } from '@/utils/common-utils';

class FinancialReportResultState {
  dayPeriod: string = getStartDayOfDate(subtractMonthsFromDate(1))

  displayColumns: Array<string> = []
}

    @Component({
      /**
         * Imported components
         * */
      components: {},
      /**
         * Stores values
         * */
      computed: {
        ...mapState({
          loading: (state: any) => state.myaaffiliate.myaaffiliateStore.loading,
          mereports: (state: any) => state.myaaffiliate.myaaffiliateStore.memonthlyreports,
        }),
      },
      /**
         * Component properties
         * */
      props: {},
    })
export default class FinancialReportResult extends mixins(SamclickMixins) {
      /**
       * Local state
       * */
      state = new FinancialReportResultState();

      payloadTemp = {};

      readonly DATE_COLUMN = 'date'

      readonly CASINO_COLUMN = 'casino'

      readonly REWARD_COLUMN = 'reward'

      readonly TIER_COLUMN = 'tier'

      readonly LAST_MONTH_COLUMN = 'last_month'

      readonly CURRENT_MONTH_COLUMN = 'current_month'

      readonly NEXT_MONTH_COLUMN = 'next_month'

      readonly COMMISSION_ADJUSTMENT_COLUMN = 'commission_adjustment'

     readonly BRAND_COMMISSION = 'brand_commission'

      readonly BRAND_WITHDRAW_COLUMN = 'brand_withdraw'

      readonly CPA_COMMISSION_COLUMN = 'cpa'

        /**
         * Watchers
         * */
        @Watch('componentState.var')
      sampleWatcher(newVal: string, oldVal: string) {

      }

        /**
       * Methods
       * */
        search() {
          const {
            dayPeriod,
          } = this.state;
          const start_date = dayPeriod;
          const history = 1;
          const payload = {
            start_date,
            history,
          };
          this.payloadTemp = payload;
          MyaaffiliateStore.MeMonthlyReport(new Payload(payload));
        }
        isBrandWithdrawVisible() {
          const data = this.mereports;
          return !!data && data.show_brand_withdraw_column === true;
        }

        reset() {
          this.state = new FinancialReportResultState();
          this.$nextTick(() => {
            this.search();
          });
        }

        generateLineConfig() {
          const setting = [
            new BasicLineSetting(this.$t('label.commissions').toString(), 'rgb(255,32,30)', 'total', 'left', true),
          ];
          return new BasicLineConfig('date', setting, 'YYYY-MM');
        }

        exportCsv() {
          const {
            dayPeriod,
          } = this.state;
          const startDate = dayPeriod;
          const payload = {
            start_date: startDate,
          };
          payload.headers = [
            this.$t('label.brand'),
            this.$t('label.commissions'),
            this.$t('label.cpa_commissions'),
            this.$t('label.tier_commission'),
            this.$t('label.commission_adjustment'),
            this.$t('reports_financial.brand_commission'),
            /*            this.$t('reports_financial.prev_carry_overs'),
            this.$t('reports_financial.next_carry_overs'), */
          ];

          if (this.isBrandWithdrawVisible()) {
            payload.headers.push(this.$t('reports_financial.brand_withdraw'));
          }

          payload.addtl_headers = [
            this.$t('reports_financial.reports_summary_csv'),
            this.$t('reports_financial.comm_this_month'),
            this.$t('reports_financial.carried_commissions'),
            this.$t('label.adjustments'),
            this.$t('reports_financial.transfer_fee'),
            this.$t('reports_financial.final_payment_amount'),
            this.$t('label.total'),
          ];
          this.payloadTemp = payload;
          MyaaffiliateStore.exportMeMonthlyReport(new Payload(this.payloadTemp));
        }

        getSummaries() {
          const data = this.mereports;
          const footer = [];

          const summary = this.$t('label.total');

          footer[0] = summary;
          footer[1] = `€ ${toMoney(this.getObject(data, 'commissions', 0.00))}`;
          footer[2] = `€ ${toMoney(this.getObject(data, 'cpa', 0.00))}`;
          footer[3] = `€ ${toMoney(this.getObject(data, 'tier_commission', 0.00))}`;
          footer[4] = `€ ${toMoney(this.getObject(data, 'commission_adjustment', 0.00))}`;
          footer[5] = `€ ${toMoney(this.getObject(data, 'brand_commission', 0.00))}`;
          // footer[3] = `€ ${this.getObject(data, 'carryover', 0.00).toFixed(2)}`;
          // footer[4] = `€ ${this.getObject(data, 'carryover_next', 0.00).toFixed(2)}`;

          return footer;
        }


        /**
       * Computed
       * */
        get computedVal() {
          return {};
        }

        /**
       * Lifecycle hooks
       * */
        created() {
          this.search();
        }

        mounted() {
        }

        beforeUpdate() {
        }

        beforeCreate() {
          this.dateUtils = {
            formatDate,
          };
          this.commonUtil = {
            getPercentageRate,
            toMoney,
          };
        }
}
